<template>
    <div class="layout-record-top-bar diagram-record-top-bar dsp-flex">
        <div class="bg1"></div>
        <div class="bg2"></div>
        <div class="layout-rtb-side" @click.passive="clickDiagram">
            <span class="diagram-top-back"><i class="iconfont icon-xiangzuo"></i></span>
        </div>
        <div class="layout-rtb-mid">
            <search-input 
                v-bind:inputId="searchInputId"
                v-bind:searchData="searchData"
                v-bind:inputFunc="inputSearch">
            </search-input>
        </div>
        <div class="layout-rtb-side" @click.passive="clickDiagram">
            <span class="diagram-top-button">起卦</span>
        </div>
    </div>
</template>

<script>
import SearchInput from '../../components/SearchInput.vue'
export default {
    name: 'DiagramTopBar',
    components: { SearchInput },
    computed: {
        searchData() {
            return this.$store.state.search.searchData;
        },
    },
    data() {
        return {
            searchInputId: 'diagramSearchInput',
        }
    },
    methods:{
        clickDiagram() {
            var curPath = this.$router.history.current.path;
            if(curPath.indexOf('embedded') != -1) {
                curPath = this.$router.history.current.fullPath;
                curPath = curPath.replace('diagramrecord', 'diagram')
                this.$router.replace(curPath);
            }else {
                this.$router.replace('/diagram');
            }
        },
        inputSearch(word) {
            if(word != ''){
                this.$store.dispatch('diagram/confirmSearchDiagram', word);
            }else{
                this.$store.state.diagram.diagramSearchList = [];
            }
        },
    }
}
</script>